import React from 'react'

function PharmacyBilling() {
  return (
    <div>Pharmacy Billing</div>
  )
}

export default PharmacyBilling